<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (イメージのみ) 表示
    </div>
    <ImageModal
      v-if="showableModal"
      :image-url="imageUrl"
      :primary-button-text="'変更する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import ImageModal from '../../components/molecules/modals/image-modal'
import imageUrl from '../../../../images/styleguide/default_giftcard.png'

export default {
  components: { ImageModal },
  data() {
    return {
      showableModal: false,
      imageUrl
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    }
  }
}
</script>
